module.exports = __webpack_public_path__ + "img/adult-book-business-297755-HiRes.2cf83b86.jpg";